import { BaseFormView } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/base-form-view';
import { BaseThankYouView } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/base-thank-you-view';
import { DigitalRetailOfferTypeAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/digital-retail-offer-type/digital-retail-offer-type-async';
import { MultiDigitalRetailOfferTypeSrpNewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/multi-digital-retail-offer-type-srp/mdr-offer-type-srp-new/multi-digital-retail-offer-type-srp-new-async';
import { MultiDigitalRetailOfferTypeSrpUsedAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/multi-digital-retail-offer-type-srp/mdr-offer-type-srp-used/multi-digital-retail-offer-type-srp-used-async';
import { MultiDigitalRetailOfferTypeAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/multi-digital-retail-offer-type/multi-digital-retail-offer-type-async';
import { MultiDigitalRetailOfferTypeThankYouViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/multi-digital-retail-offer-type/multi-digital-retail-offer-type-thank-you-view-async';
import { DealCheckAvailabilityAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/deal-check-availability/deal-check-availability-async';
import { TransparentPricingPreprodThankYouViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/transparent-pricing-preprod/transparent-pricing-preprod-thank-you-view-async';
import { TransparentPricingPriceCheckerThankYouViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/transparent-pricing-price-checker/transparent-pricing-price-checker-thank-you-view-async';
import { SrpPriceCheckerThankYouViewAsync } from 'client/site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/srp-price-checker/srp-price-checker-thank-you-view-async';
import { LeaseDealsThankYouViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/lease-deals/lease-deals-thank-you-view-async';
import { SetYourPriceThankYouViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view/set-your-price/set-your-price-thank-you-view-async';
import { PhotoflipperFormViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/photoflipper/photoflipper-form-view-async';
import { ModularFormViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/modular/modular-form-view-async';
import { SimpleInventoryViewAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/views/form-view/simple-inventory-view/simple-inventory-view-async';

import { BaseFormHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/form-header/base-form-header';
import { BaseThanksHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/thanks-header/base-thanks-header';
import { EmbeddedHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/embedded-header';
import { VdpEmbeddedHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/vdp-embedded-header';
import { PriceCheckerHeader } from 'site-modules/shared/components/price-checker/price-checker-header/price-checker-header';
import { PriceCheckerThankYouHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/price-checker-thank-you-header/price-checker-thank-you-header';
import { PhotoflipperVdpThankYouHeader } from 'client/site-modules/shared/components/lead-form/unified-lead-form/components/header/photoflipper-vdp-thank-you-header/photoflipper-vdp-thank-you-header';
import { Header } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/header';
import { ConvexHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/convex-header/convex-header';
import { GradientHeader } from 'site-modules/shared/components/lead-form/unified-lead-form/components/header/gradient-header/gradient-header';
import { ThankYouAdComponent } from 'site-modules/shared/components/lead-form/unified-lead-form/components/ads/thank-you-ads/thank-you-ad-component';

import { InventoryCard } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/inventory-card';
import { DealerCard } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-card';
import { DealerVinCard } from 'client/site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-vin-card';
import { DealerVinCheckAvailabilityCard } from 'client/site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-vin-check-availability-card';
import { DealerSimpleCard } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-simple-card';
import { DealerListItem } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-list-item';
import { DealerPriceCard } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-price-card';
import { DealerVinCardSrpNew } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-vin-card-srp-new';
import { DealerVinCardSrpUsed } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/dealer-vin-card-srp-used';

import {
  CARD_VIEW,
  HEADER_COMPONENT,
  LEAD_FORM_VIEWS,
  THANK_YOU_VIEWS,
  SUB_HEADER_COMPONENT,
  THANK_YOU_AD_COMPONENT,
  LOADING_COMPONENT,
} from './lead-form-params';

// Do not add server-side rendered form views here. Instead, use their components directly in lead form config.
// Example: client/site-modules/shared/components/lead-form/unified-lead-form-pages/embedded-lead-form.jsx
export const LF_VIEW_COMPONENT_MAP = {
  [LEAD_FORM_VIEWS.BASE]: BaseFormView,
  [LEAD_FORM_VIEWS.DIGITAL_RETAIL_OFFER_TYPE]: DigitalRetailOfferTypeAsync,
  [LEAD_FORM_VIEWS.MULTI_DIGITAL_RETAIL_OFFER_TYPE]: MultiDigitalRetailOfferTypeAsync,
  [LEAD_FORM_VIEWS.MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_NEW]: MultiDigitalRetailOfferTypeSrpNewAsync,
  [LEAD_FORM_VIEWS.MULTI_DIGITAL_RETAIL_OFFER_TYPE_SRP_USED]: MultiDigitalRetailOfferTypeSrpUsedAsync,
  [LEAD_FORM_VIEWS.PHOTOFLIPPER]: PhotoflipperFormViewAsync,
  [LEAD_FORM_VIEWS.MODULAR]: ModularFormViewAsync,
  [LEAD_FORM_VIEWS.SIMPLE_INVENTORY_VIEW]: SimpleInventoryViewAsync,
};

export const LOADING_COMPONENT_MAP = {
  [LOADING_COMPONENT.CONVEX]: ConvexHeader,
  [LOADING_COMPONENT.GRADIENT]: GradientHeader,
};

export const TY_VIEW_COMPONENT_MAP = {
  [THANK_YOU_VIEWS.BASE]: BaseThankYouView,
  [THANK_YOU_VIEWS.TRANSPARENT_PRICING_PREPROD]: TransparentPricingPreprodThankYouViewAsync,
  [THANK_YOU_VIEWS.TRANSPARENT_PRICING_PRICE_CHECKER]: TransparentPricingPriceCheckerThankYouViewAsync,
  [THANK_YOU_VIEWS.MULTI_DIGITAL_RETAIL_OFFER_TYPE]: MultiDigitalRetailOfferTypeThankYouViewAsync,
  [THANK_YOU_VIEWS.DEAL_CHECK_AVAILABILITY]: DealCheckAvailabilityAsync,
  [THANK_YOU_VIEWS.SRP_PRICE_CHECKER]: SrpPriceCheckerThankYouViewAsync,
  [THANK_YOU_VIEWS.LEASE_DEALS]: LeaseDealsThankYouViewAsync,
  [THANK_YOU_VIEWS.SET_YOUR_PRICE]: SetYourPriceThankYouViewAsync,
};

export const LF_HEADER_COMPONENT_MAP = {
  [HEADER_COMPONENT.BASE]: Header,
  [HEADER_COMPONENT.EMBEDDED]: EmbeddedHeader,
  [HEADER_COMPONENT.VDP_EMBEDDED]: VdpEmbeddedHeader,
  [HEADER_COMPONENT.PRICE_CHECKER]: PriceCheckerHeader,
  [HEADER_COMPONENT.CONVEX]: ConvexHeader,
  [HEADER_COMPONENT.GRADIENT]: GradientHeader,
};

export const LF_SUB_HEADER_COMPONENT_MAP = {
  [SUB_HEADER_COMPONENT.BASE]: BaseFormHeader,
};

export const TY_HEADER_COMPONENT_MAP = {
  [HEADER_COMPONENT.BASE]: Header,
  [HEADER_COMPONENT.PRICE_CHECKER]: PriceCheckerThankYouHeader,
  [HEADER_COMPONENT.PHOTOFLIPPER_VDP]: PhotoflipperVdpThankYouHeader,
  [HEADER_COMPONENT.CONVEX]: ConvexHeader,
  [HEADER_COMPONENT.GRADIENT]: GradientHeader,
};

export const TY_SUB_HEADER_COMPONENT_MAP = {
  [SUB_HEADER_COMPONENT.BASE]: BaseThanksHeader,
};

export const TY_ADS_COMPONENT_MAP = {
  [THANK_YOU_AD_COMPONENT.BASE]: ThankYouAdComponent,
};

export const CARD_LIST_COMPONENT_MAP = {
  [CARD_VIEW.INVENTORY]: InventoryCard,
  [CARD_VIEW.DEALER]: DealerCard,
  [CARD_VIEW.DEALER_SIMPLE]: DealerSimpleCard,
  [CARD_VIEW.DEALER_LIST]: DealerListItem,
  [CARD_VIEW.DEALER_PRICE]: DealerPriceCard,
  [CARD_VIEW.DEALER_VIN]: DealerVinCard,
  [CARD_VIEW.DEALER_VIN_CHECK_AVAILABILITY]: DealerVinCheckAvailabilityCard,
  [CARD_VIEW.DEALER_VIN_SRP_NEW]: DealerVinCardSrpNew,
  [CARD_VIEW.DEALER_VIN_SRP_USED]: DealerVinCardSrpUsed,
};
